import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import TableSort from '../tableComponents/TableSort'
import { monthabbs, operatorName, variableName, smryName } from "../js/constants"
import { formatDateRange, formatHourFilter, hasMissing, roundFixValue } from "../js/utilityRoutines"

export default function MonsmryTable(props) { 
  const { tabledata, overallData, totobscnt, totmisscnt, months_to_use, userParams, stnName } = props.results;
  const [ heads, setHeads ] = useState(() => {
      const headRow = [];
      headRow.push({text: "", id: "index", invisible: true, initSort: true, sortOrder: "asc"});
      headRow.push({text: "Year", id: "year", altSort: "index"});
      months_to_use.map((m) => {
          headRow.push({text: m <= 11 ? monthabbs[m] : monthabbs[m-12], id: m});
      })
      return headRow;
  });
  const [ tableBottom, setTableBottom ] = useState([]);
  const totMiss = totmisscnt.toLocaleString("en")
  const totObs = totobscnt.toLocaleString("en")
  const dateRange = "<br />" + formatDateRange(userParams);
  const hourFilter = "<br />" + formatHourFilter(userParams);
  const hasM = hasMissing(tabledata);
  let tableTitlePartial = smryName[userParams.smry] + " " + variableName[userParams.variable].name + " " +
      (!['max','min','mean','sum'].includes(userParams.smry) 
      ? (operatorName[userParams.operator] + " " + userParams.thresh + " " + variableName[userParams.variable].units) 
      : "(" + variableName[userParams.variable].units + ")");
  const titleText = tableTitlePartial+"<br/ >"+stnName;
  const footerText =  "Based on a total of "+totObs+" hourly observations; "+totMiss+" missing."+
    dateRange+
    hourFilter+
    hasM;

  useEffect(() => {
    let bottomMeans = {};
    var overallMean;
    Object.keys(overallData.cnt).forEach((i) => {
      if (userParams.variable === 'pcpn' && overallData.sum[i] > 0.00 && overallData.sum[i] < 0.01 ) {
        bottomMeans[i] = "T"   //catch trace sums
      } else if (overallData.cnt[i] === 0) {
        bottomMeans[i] = "M"
      } else {
        overallMean = overallData.sum[i] / overallData.cnt[i];
        bottomMeans[i] = userParams.variable === 'pcpn' && ['max','min','mean','sum'].includes(userParams.smry)
          ? roundFixValue(overallMean, 2) 
          : roundFixValue(overallMean, 1);
      }
    })
    setTableBottom([
      {...overallData.max, year: "Max", sx: {borderTop: "1.5pt solid black"}},
      {...bottomMeans, year: "Mean"},
      {...overallData.min, year: "Min"}
    ])
  },[])

  return (
    <Box sx={{my: 1}}>
      {heads &&
      <>
        <TableSort 
          titleText={titleText} 
          heads={heads}  
          tabledata={tabledata} 
          tableNoSortData={tableBottom} 
          footerText={footerText}
          />
        </>
      }
    </Box>
  )
}
